export class Employee {
    Id: number;
    Code: string;
    Name: string;
    MName: string;
    LName: string;
    UserName: string;
    Password: string;
    BranchId: number;
    Email: string;
    FromDate: Date;
    ToDate: Date;
    Default: boolean;
    PhoneNo: string;
    Education: number;
    Gender: number;
    DOB: string;
    JoiningDate: string;
    TerminationDate: string;
    EmployeeBranchId: number;
    CompanyId: number;
    SaasId: number;
    CreatedDate: Date;
    ModifiedDate: Date;
    IsActive: boolean;
    Flag: Number;

    Salutation: string;
    PresentAddress: string;
    PermanentAddress: string;
    PhotoName: string;
    Mobile : string;
    Mobile2: string;
    PersonalEmail: string;
    ManagerId: number;
    RoleId: number;
    IsStaffMaster: number; /// for savings query choosing
    PhotoFilePath : string;
}
